<template>
    <b-form-group
        label="Период отчета: "
        label-for="dateTypeSelect"
        :label-cols="3"
        :invalid-feedback="invalid_feedback"
        :state="validation_state"
    >
        <b-form-radio-group
            :id="'dateTypeSelect'+uid"
            stacked
            :name="'radio-validation'+uid"
        >
            <div class="custom-control custom-radio" v-for="t in types">
                <input
                    type="radio"
                    :id="'reportType_'+uid+t"
                    name="reportDateType"
                    class="custom-control-input"
                    :value="t"
                    :state="validation_state"
                    v-model="_type"
                >
                <label class="custom-control-label" :for="'reportType_'+uid+t">{{type_names[t]}}</label>
            </div>
        </b-form-radio-group>
    </b-form-group>
</template>

<script>
    import {random} from "../shared/utils";

    export default {
        name: "ReportDates",
        data: function() {
            return {
                type_names: {
                    checkin: 'По дате заезда',
                    checkout: 'По дате выезда',
                    created: 'По дате создания',
                    schet_date: 'По дате счета агентства',
                    bill_date: 'По дате счета системы',
                    invoice_date: 'По дате счета объекта',
                    invoice_redemption_date: 'По крайней дате оплаты счета объекта',
                    schet_payed: 'По дате оплаты счета агентства',
                    bill_payed: 'По дате оплаты счета системы',
                    bill_redemption_date: 'По крайней дате оплаты счета объекта',
                    invoice_payed: 'По дате оплаты счета объекта',
                    any_period_day: 'Хотя бы одна дата путевки',
                    combined_dates: 'По дате начисления вознаграждения',
                },
                uid: random(0,2000000000)
            }
        },
        props: {
            type: String,
            types: Array,
            validation_state:Boolean,
            invalid_feedback: String,
        },
        model: {
            prop: "type",
            event: "input"
        },
        computed: {
            _type: {
                get: function() {
                    return this.type
                },
                set: function (val) {
                    this.$emit("input", val);
                }
            }
        }
    }
</script>
